import axios from 'axios'
import { REACT_APP_API_URL } from './axiosInstance'


export const axiosClassic = axios.create({
	baseURL: REACT_APP_API_URL
})
